import "./User.scss";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Input, Tabs } from "antd";

import Swal from "sweetalert2";

import ApiService from "../../apis/ApiService_mall";
import { adjRandomList, nameRandomList } from "../../pages/user/LoginUitls";
import { setLoading } from "../../redux/store/common/commonDuck";
import { loginLog } from "../../utils/useUser";
// import LinkComponent from "../layout/LinkComponent";

import SignUpHeader from "./SignUpHeader";

const api = new ApiService();
const SignUpComponent = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [userValue, setUserValue] = useState({
		name: "",
		phone: "",
		phone_valid: "",
		password: "",
		password_valid: "",
	});
	const [agreement, setAgreement] = useState({
		policy: false,
		terms: false,
	});

	const [phoneValid, setPhoneValid] = useState(false); // 인증번호 전송
	const [isPhoneValid, setIsPhoneValid] = useState(false); // 인증번호 확인

	const [passwordRegValid, setPasswordRegValid] = useState(false); // 비밀번호 대소문자,숫자,특수문자 true/false
	const [passwordCheckValid, setPasswordCheckValid] = useState(false); // 비밀번호 확인

	const [inputValid, setInputValid] = useState(false); // 전체 의동의

	const [snsUserInfo, setSnsUserInfo] = useState(null);
	useEffect(() => {
		window.scrollTo({ top: 0 });
		handleSnsUser();
	}, []);

	const handleSnsUser = () => {
		const snsUserInfoSession = JSON.parse(
			sessionStorage.getItem("snsUserInfo")
		);
		if (snsUserInfoSession) {
			setSnsUserInfo(snsUserInfoSession);
		}
	};

	useEffect(() => {
		if (userValue.name?.length === 0) {
			randomNickname();
		}
	}, [userValue]);

	/**
	 * 회원 정보 받기
	 * @type {(function(*): void)|*}
	 */
	const handleInputUser = useCallback(
		(e) => {
			const { value, name } = e.target;
			if (name === "phone") {
				if (value.split("-").join("").length <= 11) {
					let phone = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						phone: phone,
					});
				}
			} else if (name === "phone_valid") {
				if (value.split("-").join("").length <= 6) {
					let phone_valid = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						phone_valid: phone_valid,
					});
				}
			} else if (name === "password") {
				let password = value;
				// 특수문자 / 문자 / 숫자 포함 형태의 8~16 자리 이내의 암호 정규식
				let regPass =
					/^.*(?=^.{8,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
				if (password.match(regPass)) {
					setPasswordRegValid(true);
				} else {
					setPasswordRegValid(false);
				}

				// 숫자, 문자, 특수문자만 입력 가능
				const regExp = /[^0-9a-zA-Z!@#$%^&+=]/g;
				if (regExp.test(value)) {
					password = value.replace(regExp, "");
				}
				setUserValue({
					...userValue,
					[name]: password,
				});

				const regPassword =
					/^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z\\d`~!@#$%^&*()-_=+(?=.*\d)]{8,}$/;
				if (regPassword.test(e.target.value)) {
					if (!passwordRegValid) setPasswordRegValid(true);
				} else {
					if (passwordRegValid) setPasswordRegValid(false);
				}
			} else if (name === "password_valid") {
				setUserValue({
					...userValue,
					[name]: value,
				});
				if (userValue.password === value) {
					setPasswordCheckValid(true);
				} else {
					setPasswordCheckValid(false);
				}
			} else {
				setUserValue({
					...userValue,
					[name]: value,
				});
			}
		},
		[userValue]
	);

	/**
	 * step 2-1 : 휴대폰 인증
	 */
	const sendPhoneValid = async () => {
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		if (regPhone.test(userValue.phone)) {
			setIsLoading(true);

			//ios 심사를 위한 핸드폰 번호
			if (userValue.phone === "01012345678") {
				setIsLoading(false);
			} else {
				let param = { phone: userValue.phone, is_user_valid: true };
				let res = await api.smsCertifySend(param);

				if (res.data.code === 200) {
					if (res.data.result?.id_check === true) {
						const loginMethod =
							res.data.result.user?.provider === "kakao"
								? "카카오"
								: res.data.result.user?.provider === "naver"
								? "네이버"
								: "해당 번호";

						Swal.fire({
							customClass: "alert-custom",
							text: `${loginMethod}로 가입된 유저가 있습니다. 로그인 하시겠습니까?`,
							// confirmButtonColor: "#212529",
						}).then((res) => {
							if (res.isConfirmed) {
								history.push(`/login`);
							}
						});
					} else {
						setPhoneValid(true);
						setIsLoading(false);
					}
					setIsLoading(false);
				} else {
					setIsLoading(false);
				}
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "휴대폰 번호를 정확하게 입력해주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	/**
	 * step 2-2: 휴대폰 인증번호 일치 확인
	 */
	const checkPhoneValid = async () => {
		const regPhone = /([0-9]{6})$/;
		if (regPhone.test(userValue.phone_valid)) {
			setIsLoading(true);

			let param = {
				phone: userValue.phone,
				sms_verify_code: userValue.phone_valid,
			};
			let res = await api.smsCertifyVerify(param);

			if (res.data.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치합니다.",
					// confirmButtonColor: "#212529",
				});
				setIsPhoneValid(true);
				// setTabIndex(4);
				setIsLoading(false);
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치하지 않습니다.",
					// confirmButtonColor: "#212529",
				});
				// setIsSmsValid(true);
				setIsLoading(false);
			}
			// }
			// }
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "휴대폰 번호를 정확하게 입력해주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	/**
	 * 입력 값 밸리데이션 -> signupValue 변할 때 마다 적용
	 */
	useEffect(() => {
		const { phone, password } = userValue;
		if (
			phone?.replaceAll("-", "").length !== 11 ||
			!phoneValid ||
			!isPhoneValid ||
			!passwordRegValid ||
			!passwordCheckValid
			// name.length === 0 ||
			// birthday.length === 0
		) {
			if (inputValid) {
				setInputValid(false);
			}
		} else {
			if (agreement.terms && agreement.policy) {
				setInputValid(true);
			} else {
				setInputValid(false);
			}
		}
	}, [passwordRegValid, userValue, agreement]);

	/**
	 * 가입하기 버튼 클릭
	 */
	const handleSignupButton = () => {
		let snsValid = snsUserInfo && agreement.policy && agreement.terms;
		let normalValid =
			isPhoneValid &&
			passwordCheckValid &&
			userValue.name?.length > 0 &&
			agreement.policy &&
			agreement.terms;

		if (snsValid || normalValid) {
			let query = sessionStorage.getItem("login-influencer");
			setIsLoading(true);
			const timer = setTimeout(() => {
				if (query) {
					postUserChannelJoin();
				} else {
					userJoin();
				}
			}, 100);
			return () => clearTimeout(timer);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "필수 입력 항목을 모두 적어주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	// 인플루언서 확인 후 회원가입
	const postUserChannelJoin = async () => {
		let query = sessionStorage.getItem("login-influencer");
		let param = {
			provider: null,
			provider_id: null,
			phone: userValue.phone,
			password: userValue.password,
			nickname: userValue.name.trim(),
			query: query,
		};
		if (snsUserInfo) {
			param = {
				...param,
				provider_id: snsUserInfo.provider_id,
				provider: snsUserInfo.provider,
				phone: snsUserInfo.phone_number
					?.replaceAll("-", "")
					?.replaceAll("+82 ", "0")
					.trim(),
			};
		}
		const res = await api.userChannelJoin(param);
		if (res.data.code === 200) {
			localStorage.removeItem("login-influencer");
			let result = res.data.result;

			// 회원가입 로그 남기기
			loginLog(
				result.user,
				"singup-dangyoung" + (query ? ` query: ${query}` : "")
			);

			localStorage.removeItem("admin:accessToken");
			localStorage.removeItem("admin:refreshToken");

			Swal.fire({
				customClass: "alert-custom",
				text: "정상적으로 회원가입이 완료 되었습니다.",
				// confirmButtonColor: "#212529",
			}).then(() => {
				history.push(`/login`);
			});

			setIsLoading(false);
		} else {
			setIsLoading(true);
			userJoin();
		}
		setIsLoading(false);
	};

	/**
	 * 회원가입 api 호출
	 * + 회원가입시, query가 있으면 해당값 param에 추가 (2024.01.29) - ksb
	 */
	const userJoin = async () => {
		const query = sessionStorage.getItem("query");
		let param = {
			nickname: userValue.name.trim(),
			gender: "",
			birthday: "",
			age: "",
			// provider: "user",
			password: userValue.password,
			phone: userValue.phone,
		};
		if (query) {
			param["query"] = query;
		}
		if (snsUserInfo) {
			param = {
				...param,
				provider_id: snsUserInfo.provider_id,
				provider: snsUserInfo.provider,
				phone: snsUserInfo.phone_number
					?.replaceAll("-", "")
					?.replaceAll("+82 ", "0")
					.trim(),
			};
		}
		let res = await api.userJoin(param);
		if (res.data.code === 200) {
			const regSuccessData = res.data.result;

			// 회원가입 로그 남기기
			loginLog(
				regSuccessData.user,
				"singup-dangyoung" + (query ? ` query: ${query}` : "")
			);

			localStorage.removeItem("admin:accessToken");
			localStorage.removeItem("admin:refreshToken");

			Swal.fire({
				customClass: "alert-custom",
				text: "정상적으로 회원가입이 완료 되었습니다.",
				// confirmButtonColor: "#212529",
			}).then(() => {
				history.push(`/login`);
			});

			setIsLoading(false);
		} else {
			// window.alert("일시적인 오류로 실패하였습니다. 다시 시도해주세요.");
			Swal.fire({
				customClass: "alert-custom",
				text: "일시적인 오류로 실패하였습니다. 다시 시도해주세요.",
				// confirmButtonColor: "#212529",
			});
			setIsLoading(false);
		}
	};

	/**
	 * 랜덤 닉네임
	 * @returns {Promise<string>}
	 */
	const randomNickname = async () => {
		let random_nickname = "";

		random_nickname +=
			adjRandomList[Math.floor(Math.random() * adjRandomList.length)];
		random_nickname +=
			nameRandomList[Math.floor(Math.random() * nameRandomList.length)];

		const random = (Math.random() * 10000).toFixed();
		random_nickname += random;

		let param = {
			nickname: random_nickname,
		};
		let res = await api.nicknameValid(param);

		if (res.data.code === 200) {
			setUserValue({
				...userValue,
				name: random_nickname,
			});
			return random_nickname;
		} else {
			randomNickname();
		}
	};

	return (
		<div className="main-wrap">
			{/* 모바일 헤더 추가 */}
			<SignUpHeader
				title={`${
					snsUserInfo?.provider === "kakao"
						? "카카오 계정으"
						: snsUserInfo?.provider === "naver"
						? "네이버 계정으"
						: "휴대폰 번호"
				}로 가입하기`}
			/>
			<div className="max-width-apply">
				{/* 기본 정보 */}
				<div className={`signup-form-parents`}>
					<h1
						className={`main-title`}
						id={`main-title`}
						style={{ margin: 0, paddingBottom: "0.5em" }}
					>
						{snsUserInfo?.provider === "kakao"
							? "카카오 계정으"
							: snsUserInfo?.provider === "naver"
							? "네이버 계정으"
							: "휴대폰 번호"}
						로 가입하기
					</h1>
					{!snsUserInfo && (
						<>
							<div className={`signup-component-list`}>
								<h2>기본 정보</h2>
							</div>

							<div className={`signup-form-wrap`}>
								<div
									className={`signup-form-item ${
										phoneValid ? "padding" : "divider"
									}`}
								>
									<label>휴대폰 번호</label>
									<div className={`input-div phone`}>
										<Input
											type={`text`}
											placeholder={`- 없이 입력해주세요.`}
											value={userValue.phone}
											name={"phone"}
											onChange={handleInputUser}
											pattern={`/d*`}
											disabled={isPhoneValid || !!snsUserInfo}
										/>
										<Button
											loading={isLoading}
											disabled={isPhoneValid || !!snsUserInfo}
											onClick={sendPhoneValid}
										>
											인증
										</Button>
									</div>
								</div>
								{phoneValid && (
									<div
										className={`signup-form-item divider`}
										style={{ paddingTop: 0 }}
									>
										<label>인증번호</label>
										<div className={`input-div phone`}>
											<Input
												type={`text`}
												// placeholder={`- 없이 입력해주세요.`}
												value={userValue.phone_valid}
												name={"phone_valid"}
												onChange={handleInputUser}
												pattern={`/d*`}
												disabled={isPhoneValid || !!snsUserInfo}
											/>
											<Button
												loading={isLoading}
												disabled={isPhoneValid || !!snsUserInfo}
												onClick={checkPhoneValid}
											>
												인증완료
											</Button>
										</div>
									</div>
								)}
								{!snsUserInfo && (
									<div className={`signup-form-item padding`}>
										<label>비밀번호</label>
										<div className={`input-div`}>
											<Input
												type={`password`}
												placeholder={`8자리 이상 비밀번호를 입력해주세요. (최소 영문, 숫자 1개 이상 포함)`}
												value={userValue.password}
												name={"password"}
												onChange={handleInputUser}
												pattern={`/d*`}
												style={{
													borderColor:
														userValue.password?.length > 0 &&
														!passwordRegValid &&
														"red",
												}}
											/>
										</div>
									</div>
								)}
								{!snsUserInfo && (
									<div className={`signup-form-item padding`}>
										<label>비밀번호 확인</label>
										<div className={`input-div`}>
											<Input
												type={`password`}
												placeholder={``}
												value={userValue.password_valid}
												name={"password_valid"}
												onChange={handleInputUser}
												pattern={`/d*`}
												style={{
													borderColor:
														userValue.password_valid?.length > 0 &&
														!passwordCheckValid &&
														"red",
												}}
											/>
										</div>
									</div>
								)}
							</div>
						</>
					)}
				</div>

				{/* 약관동의 */}
				<div className={`signup-form-parents`} style={{ marginTop: "3em" }}>
					<div className={`signup-component-list`}>
						<h2>약관동의</h2>
					</div>

					<div className={`signup-form-wrap`}>
						<div className={`signup-agreement-wrap`}>
							<div
								className={`signup-agreement-div`}
								onClick={() => {
									setAgreement({
										...agreement,
										policy: !agreement?.policy,
									});
								}}
							>
								<img
									src={`/assets/images/check-${
										agreement.policy ? "active" : "disabled"
									}.png`}
									alt={`약관 동의 1`}
								/>
								<p>[필수] 개인정보 처리방침</p>
								<img
									src={`/assets/images/channel/right-arrow.png`}
									alt={`화살표`}
									style={{
										height: "2em",
										width: "2em",
										marginLeft: "auto",
									}}
									onClick={(e) => {
										e.stopPropagation();
										window.open("https://www.dangyoung.com/policy", "_blank");
									}}
								/>
							</div>
							<p style={{ color: "#a9b0b7" }}>
								회원님의 소중한 정보를 안전하게 지키겠다는 약속이에요.
							</p>
						</div>

						<div className={`signup-agreement-wrap`}>
							<div
								className={`signup-agreement-div`}
								onClick={() => {
									setAgreement({
										...agreement,
										terms: !agreement?.terms,
									});
								}}
							>
								<img
									src={`/assets/images/check-${
										agreement.terms ? "active" : "disabled"
									}.png`}
									alt={`약관 동의 2`}
								/>
								<p>[필수] 서비스 이용약관</p>
								<img
									src={`/assets/images/channel/right-arrow.png`}
									alt={`화살표`}
									style={{
										height: "2em",
										width: "2em",
										marginLeft: "auto",
									}}
									onClick={(e) => {
										e.stopPropagation();
										window.open("https://www.dangyoung.com/terms", "_blank");
									}}
								/>
							</div>
							<p style={{ color: "#a9b0b7" }}>
								회원님에게 안정적인 서비스를 제공드리겠다는 약속이에요.
							</p>
						</div>
					</div>
				</div>
				<div className={`signup-blue-button-wrap`}>
					<Button
						loading={isLoading}
						className={`signup-blue-button`}
						onClick={handleSignupButton}
					>
						가입
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SignUpComponent;
